import React, { useState, useEffect } from "react";
import { __ } from "@wordpress/i18n";
import { BigLoader } from "../gutenberg/src/icons";
import { Chart as ChartJS } from "chart.js/auto";
import { Bar, Line } from "react-chartjs-2";

const Dashboard = () => {
	const [loading, setLoading] = useState(true);
	const [statistics, setStatistics] = useState({});

	useEffect(() => {
		loadStatistics();
		headway_init();
	}, []);

	const headway_init = () => {
		const url = '//cdn.headwayapp.co/widget.js'
		const headway = document.createElement('script')
		headway.type = 'text/javascript'
		headway.async = true
		headway.src = url
		document.getElementsByTagName('head')[0].appendChild( headway );
	
		// onload 
		headway.onload = () => {
			Headway.init({
			selector: ".easy_email_integration-wrap .eei_headway",
			account: '7OdDVJ'
			});
		}
	}

	const loadStatistics = async () => {
		setLoading(true);
		const response = await fetch(`${easy_email_integration.ajaxurl}/eei/v1/statistics`);
		if (response.status !== "error") {
			const data = await response.json();
			setStatistics(data);
		} else {
			setNotification({
				status: "error",
				message: __("Sorry, there was some error loading data", "easy-email-integration"),
			});
		}
		setLoading(false);
	};

	const calculate7Days = (states) => {
		return Object.values(states)
			.map((item) => parseInt(item.subscribers))
			.reduce((a, b) => a + b, 0);
	};

	const calculateConversionRate = (states) => {
		
		let sevendaysvisitors = Object.values(states)
			.map((item) => parseInt(item.visitors))
			.reduce((a, b) => a + b, 0);

		let sevendayssubscribes = Object.values(states)
			.map((item) => parseInt(item.subscribers))
			.reduce((a, b) => a + b, 0);
		console.log(sevendaysvisitors)

		if (sevendaysvisitors === 0 && sevendayssubscribes === 0) {
			return 0;
		} else {
			const conversionRate = Math.round((sevendayssubscribes / sevendaysvisitors) * 100);
        	return conversionRate;

		}
	};

	const daysnames = [
		__("Sun", "easy-email-integration"),
		__("Mon", "easy-email-integration"),
		__("Tue", "easy-email-integration"),
		__("Wed", "easy-email-integration"),
		__("Thu", "easy-email-integration"),
		__("Fri", "easy-email-integration"),
		__("Sat", "easy-email-integration"),
	];

	const weekComparisionData = (states) => {
		var thisweekenties = Object.entries(states.thisweek)
			.map((item) => {
				return {
					date: new Date(item[0]).toISOString(),
					subscribers: item[1].subscribers,
				};
			})
			.sort((a, b) => a.date - b.date);

		var thisweekvalues = thisweekenties.map((item) => item.subscribers);

		var lastweekvalues = Object.entries(states.lastweek)
			.map((item) => {
				return {
					date: new Date(item[0]).toISOString(),
					subscribers: item[1].subscribers,
				};
			})
			.sort((a, b) => a.date - b.date)
			.map((item) => item.subscribers);

		var days = thisweekenties.map((item) => {
			return daysnames[new Date(item.date).getDay()];
		});

		let data = {
			labels: days,
			datasets: [
				{
					label: __("This week", "easy-email-integration"),
					data: thisweekvalues,
					backgroundColor: "#367dff",
				},
				{
					label: __("Last week", "easy-email-integration"),
					data: lastweekvalues,
					backgroundColor: "#4fc9a7",
				},
			],
		};

		return data;
	};

	const performanceComparisionData = (states) => {
		var thisweekenties = Object.entries(states)
			.map((item) => {
				return {
					date: new Date(item[0]).toISOString(),
					subscribers: item[1].subscribers,
					visitors: item[1].visitors,
				};
			})
			.sort((a, b) => a.date - b.date);
		var thisweeksubscribers = thisweekenties.map((item) => item.subscribers);
		var thisweekvisitors = thisweekenties.map((item) => item.visitors);
		var days = thisweekenties.map((item) => daysnames[new Date(item.date).getDay()]);

		let data = {
			labels: days,
			datasets: [
				{
					label: __("Subscriber", "easy-email-integration"),
					data: thisweeksubscribers,
					borderColor: "#4fc9a7",
					borderWidth: 1,
					cubicInterpolationMode: "monotone",
					tension: 0.4,
					fill: true,
					backgroundColor: "rgba(79, 201, 167, 0.24)",
				},
				{
					label: __("Visitor", "easy-email-integration"),
					data: thisweekvisitors,
					borderColor: "#367dff",
					borderWidth: 1,
					cubicInterpolationMode: "monotone",
					tension: 0.4,
					fill: true,
					backgroundColor: "rgba(54, 125, 255, 0.24)",
				},
			],
		};
		return data;
	};

	const weekComparisionChartOptions = {
		plugins: {
			legend: { position: "bottom" },
		},
		scales: {
			y: {
				ticks: {
					stepSize: 1,
				},
				grid: {
					color: "transparent",
					lineWidth: 2,
					borderWidth: 2,
					tickColor: "#e5e5e5",
				},
			},
			x: {
				grid: {
					color: "transparent",
					lineWidth: 2,
					borderWidth: 2,
					tickColor: "#e5e5e5",
				},
			},
		},
	};
	const convertComparisionChartOptions = {
		plugins: {
			legend: { position: "bottom" },
		},
		scales: {
			y: {
				ticks: {
					stepSize: 1,
				},
				grid: {
					borderDash: [4, 2],
					lineWidth: 2,
					borderWidth: 2,
				},
			},
			x: {
				grid: {
					borderDash: [4, 2],
					lineWidth: 2,
					borderWidth: 2,
				},
			},
		},
	};

	return (
		<div>
			<div className="eeiheading">
			<h2 className="title">{__("Dashboard", "easy-email-integration")}</h2>
			<h3 className="eei_headway"><span className="emoji"> 😍 </span> What's new?</h3>
			</div>
			<div className="option-form-field-wrap">
				<div className="easy_email_integration-statistics">
					{loading ? (
						<div className="eei-loader">
							<BigLoader />
						</div>
					) : (
						<React.Fragment>
							<div className="eei-dashboard-box">
								<div className="easy_email_integration-row">
									<div className="easy_email_integration-col-6">
										<div className="eei_subscription_count">
											<span className="dashicons dashicons-admin-users"></span>
											<div className="eei_subscription_data">
												<span className="today">
													<label>
														{__("Daily Subscription", "easy-email-integration")}
													</label>
													<span className="count">
														{
															statistics.thisweek[
																new Date().toISOString().slice(0, 10)
															].subscribers
														}
													</span>
												</span>
												<span className="sevenday">
													<label>
														{__(
															"Subscribed in last 7 days",
															"easy-email-integration"
														)}
													</label>
													<span className="count">
														{calculate7Days(statistics.thisweek)}
													</span>
												</span>
											</div>
										</div>
									</div>
									<div className="easy_email_integration-col-6">
										<div className="eei_subscription_conversion_rate">
											<label>
												{__("Conversion Rate", "easy-email-integration")}
											</label>
											<div className="conversion_rate">
												<span className="dashicons dashicons-chart-bar"></span>
												<span className="count">
													{calculateConversionRate(statistics.thisweek)}
													{__("%", "easy-email-integration")}
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="easy_email_integration-row">
								<div className="easy_email_integration-col-6">
									<div className="eei_weekly_trend eei_dashbaord_widget">
										<div className="eei_widget_header">
											<h4>{__("Weekly Trends", "easy-email-integration")}</h4>
											<p>
												{__(
													"Weekly Subscribers Trend (This Week vs Last Week)",
													"easy-email-integration"
												)}
											</p>
										</div>
										<Bar
											data={weekComparisionData(statistics)}
											options={weekComparisionChartOptions}
										/>
									</div>
								</div>
								<div className="easy_email_integration-col-6">
									<div className="eei_weekly_performance eei_dashbaord_widget">
										<div className="eei_widget_header">
											<h4>{__("Performance", "easy-email-integration")}</h4>
											<p>
												{__(
													"Weekly Visitors vs Subscriptions",
													"easy-email-integration"
												)}
											</p>
										</div>
										<Line
											data={performanceComparisionData(statistics.thisweek)}
											options={convertComparisionChartOptions}
										/>
									</div>
								</div>
							</div>
						</React.Fragment>
					)}
				</div>
			</div>
		</div>
	);
};

export default Dashboard;